import { CurrencyProps } from "./currency.types";

export enum Locale {
  BR = "pt-BR",
}

export const formatCurrency = (
  value: CurrencyProps = 0,
  hasExpoent = false,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  shouldFormatCents = false,
) => {
  const normalizedValue =
    typeof value === "string" && value
      ? (value as string).replace(/\./g, "").replace(",", ".")
      : value;

  const numericValue =
    typeof normalizedValue === "string"
      ? parseFloat(normalizedValue)
      : normalizedValue;

  return new Intl.NumberFormat(Locale.BR, {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits,
    maximumFractionDigits,
    ...(hasExpoent
      ? {
          notation: "compact",
          compactDisplay: "short",
        }
      : {}),
  }).format(shouldFormatCents ? numericValue / 100 : numericValue);
};

export const formatCurrencyToFloat = (str: string) =>
  parseFloat(str.replace(/[^0-9,]+/g, "").replace(",", "."));
